import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  h1Custom: {
    color: "gray",
    padding: 15,
  },
}));

export { useStyles };
